export default __webpack_public_path__ + "static/media/home-bg-six.2832a838.avif";